// extracted by mini-css-extract-plugin
export default {"CheckboxButton":"bGpJjWHPZV6_ZX7Jrwnq","CheckboxGroup":"ZM3TyCuMxMuPpOh1qKS1","Checkbox":"u_m8GfY9rNy9T9HxGRSS"};